
<form (ngSubmit)="onSubmit()" class="password-change-form" #changeForm="ngForm">
  <mat-form-field>
      <input type="password" matInput placeholder="現在のパスワード" id="currentPass" [(ngModel)]="currentPassword" name="currentPass" #key="ngModel" autocomplete="off" required>
      <mat-error *ngIf="key.invalid">パスワードの入力は必須です</mat-error>
  </mat-form-field>
  <mat-form-field>
    <input [type]="confirmPasswordHided ? 'password' : 'text'" matInput placeholder="新しいパスワード" id="newPass" [(ngModel)]="newPassword" name="newPass" #key="ngModel" autocomplete="off"
      required
      minlength="6"
      pattern="(?=.*\d)(?=.*[a-zA-Z]).{6,}"
      #newPass="ngModel">
    <mat-icon matSuffix (click)="confirmPasswordHided = !confirmPasswordHided">{{confirmPasswordHided ? 'visibility' : 'visibility_off'}}</mat-icon>
    <mat-error *ngIf="newPass.errors?.required">パスワードの入力は必須です</mat-error>
    <mat-error *ngIf="newPass.errors?.minlength">6文字以上のパスワードを指定してください</mat-error>
    <mat-error *ngIf="newPass.errors?.pattern && !newPass.errors?.minlength">英字・数字それぞれ1文字以上指定してください</mat-error>
  </mat-form-field>
  <mat-form-field>
    <input type="password" matInput placeholder="新しいパスワード(確認)" id="newPassConfirm" [(ngModel)]="newPassConfirm" name="newPassConfirm" #key="ngModel" autocomplete="off" required>
  </mat-form-field>
  <button type="submit" mat-raised-button color="primary" [disabled]="changeForm.invalid">変更する</button>
  <span *ngIf="FailurePasswordChange" class="errorMessage">パスワードの変更に失敗しました</span>
  <span *ngIf="PasswordConfirmInvalid" class="errorMessage">パスワードが一致しません</span>
  <span *ngIf="complatePasswordChange" >パスワード変更が完了しました</span>

</form>
